export default (params) => params
  .replace('?', '')
  .split('&')
  .map((param) => param.split('='))
  .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})
